import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import Login from "./components/screens/auth/Login";
import Dashboard from "./components/screens/main/Dashboard";
import Clients from "./components/screens/main/Clients";
import CreateClient from "./components/screens/main/CreateClient";
import Invoices from "./components/screens/main/Invoices";
import Reports from "./components/screens/main/Reports";
import Settings from "./components/screens/main/Settings";
import Lockscreen from "./components/screens/auth/Lockscreen";
import CreateInvoice from "./components/screens/main/CreateInvoice";
import Products from "./components/screens/main/Products";
import CreateProduct from "./components/screens/main/CreateProduct";
import EditInvoice from "./components/screens/main/EditInvoice";
import InvoiceDetails from "./components/screens/main/InvoiceDetails";
import RecurringInvoices from "./components/screens/main/RecurringInvoices";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = !!Cookies.get("token");
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const PublicRoute = ({ children }) => {
  const isAuthenticated = !!Cookies.get("token");
  return !isAuthenticated ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/lockscreen" element={<PublicRoute><Lockscreen /></PublicRoute>} />

          {/* Protected Routes */}
          <Route path="/" element={<ProtectedRoute><Dashboard/></ProtectedRoute>} /> 
          <Route path="/clients" element={<ProtectedRoute><Clients /></ProtectedRoute>} />
          <Route path="/create-client" element={<ProtectedRoute><CreateClient /></ProtectedRoute>} />
          <Route path="/invoices" element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
          <Route path="/invoices/recurring" element={<ProtectedRoute><RecurringInvoices /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings/></ProtectedRoute>}/>
          <Route path="/create-invoice" element={<ProtectedRoute><CreateInvoice /></ProtectedRoute>} />
          <Route path="/edit-invoice/:id" element={<ProtectedRoute><EditInvoice /></ProtectedRoute>} />
          <Route path="/invoice-details/:id" element={<ProtectedRoute><InvoiceDetails /></ProtectedRoute>} />
          <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
          <Route path="/create-product" element={<ProtectedRoute><CreateProduct /></ProtectedRoute>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
